module.exports = __webpack_public_path__ + "17_hair_brown.d5200366.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/17_hair_brown.png
// module id = 0O5t
// module chunks = 0